import { Pressable, SxProp, useDripsyTheme } from 'dripsy';
import React from 'react';
import { Icon, SVGIconList } from '../../icons/Icon';
import { TextBody } from '../../typography';

export interface HyperlinkButtonProps {
  label: string;
  onPress: () => void;
  icon?: SVGIconList;
  iconPosition?: 'left' | 'right';
  iconSize?: number;
  disabled?: boolean;
  sx?: SxProp;
}

export const HyperlinkButton: React.FC<HyperlinkButtonProps> = ({
  label,
  icon,
  iconPosition = 'left',
  iconSize = 20,
  onPress,
  disabled,
  sx
}) => {
  const { theme } = useDripsyTheme();
  const iconColor = disabled ? theme.colors?.$disable : theme.colors?.$primary;

  return (
    <Pressable onPress={onPress} sx={{ ...styles.container, ...sx }}>
      {iconPosition === 'left' && icon && <Icon name={icon} height={iconSize} width={iconSize} color={iconColor} themeColor={iconColor} />}
      <TextBody sx={{ color: disabled ? '$disable' : '$textHyperlink' }}>{label}</TextBody>
      {iconPosition === 'right' && icon && <Icon name={icon} height={iconSize} width={iconSize} color={iconColor} themeColor={iconColor} />}
    </Pressable>
  );
};

enum StyleName {
  container = 'container'
}

const styles: Record<StyleName, SxProp> = {
  container: {
    gap: '$2',
    flexDirection: 'row',
    alignItems: 'center'
  }
};
